<div class="wide-interaction-bar-wrapper">
  <app-messages-header></app-messages-header>
  <div class="wide-interaction-bar-content">
    @if ((selectedView$ | async) === MESSAGING_VIEWS.DISCUSSION_LIST) {
      <app-discussions-list></app-discussions-list>
    }
    @if ((selectedView$ | async) === MESSAGING_VIEWS.DISCUSSION_CREATE) {
      <app-discussions-create
      ></app-discussions-create>
    }
    @if ((selectedView$ | async) === MESSAGING_VIEWS.DISCUSSION_VIEW) {
      <app-discussions-view></app-discussions-view>
    }
    @if ((selectedView$ | async) === MESSAGING_VIEWS.DISCUSSION_THREAD_VIEW) {
      <app-discussion-thread-view
      ></app-discussion-thread-view>
    }
  </div>
</div>
